import { useState } from 'react';
import {
  makeStyles,
  tokens,
  Card,
  Title2,
  Body1,
  Button,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from '@fluentui/react-components';
import { CheckmarkCircleRegular } from '@fluentui/react-icons';
import { OnboardingWizard } from '../components/onboarding/OnboardingWizard';

const useStyles = makeStyles({
  container: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  header: {
    marginBottom: tokens.spacingVerticalXL,
  },
  title: {
    marginBottom: tokens.spacingVerticalS,
  },
  subtitle: {
    color: tokens.colorNeutralForeground3,
  },
  successCard: {
    padding: tokens.spacingVerticalXXL,
    textAlign: 'center',
  },
  successIcon: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundColor: '#e6f4ea',
    color: '#137333',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    marginBottom: tokens.spacingVerticalL,
    fontSize: '32px',
  },
  successTitle: {
    marginBottom: tokens.spacingVerticalM,
  },
  successMessage: {
    color: tokens.colorNeutralForeground3,
    marginBottom: tokens.spacingVerticalXL,
    maxWidth: '400px',
    margin: '0 auto',
  },
});

export function OnboardingPage() {
  const styles = useStyles();
  const [isComplete, setIsComplete] = useState(false);
  const [requestId, setRequestId] = useState<string | null>(null);

  const handleComplete = (id: string) => {
    setRequestId(id);
    setIsComplete(true);
  };

  const handleReset = () => {
    setIsComplete(false);
    setRequestId(null);
  };

  if (isComplete) {
    return (
      <div className={styles.container}>
        <Card className={styles.successCard}>
          <div className={styles.successIcon}>
            <CheckmarkCircleRegular />
          </div>
          <Title2 className={styles.successTitle}>
            Onboarding Request Submitted!
          </Title2>
          <Body1 className={styles.successMessage}>
            Your request has been submitted successfully and is pending approval.
            You will receive an email notification once it has been reviewed.
          </Body1>
          {requestId && (
            <MessageBar intent="info" style={{ marginBottom: tokens.spacingVerticalL }}>
              <MessageBarBody>
                <MessageBarTitle>Request ID: {requestId}</MessageBarTitle>
                Save this ID for your records.
              </MessageBarBody>
            </MessageBar>
          )}
          <Button appearance="primary" onClick={handleReset}>
            Submit Another Request
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title2 className={styles.title}>New Employee Onboarding</Title2>
        <Body1 className={styles.subtitle}>
          Fill out the form below to request a new employee account
        </Body1>
      </div>

      <OnboardingWizard onComplete={handleComplete} />
    </div>
  );
}
